import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import BackMethods from "../back_component/BackMethods";
import "./Sidebar.css";

const isRouteActive = (pathname, targetPath) => {
  const norm = (p) => (p || "").replace(/\/$/, "") || "/";
  const loc = norm(pathname);
  const target = norm(targetPath);
  if (target === "/admin" || targetPath === "/admin/") {
    return loc === "/admin" || loc === "";
  }
  return loc === target || loc.startsWith(`${target}/`);
};

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});
  const [isScrolled, setIsScrolled] = useState(false);
  const { getUserConstraints } = BackMethods();
  const [isAdmin] = useState(() => getUserConstraints().isSuperAdmin);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth < 992 && isOpen) {
      toggleSidebar();
    }
  }, [location.pathname]);

  const toggleMenu = (label) => {
    setOpenMenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const menuStructure = [
    { path: "/admin/", label: "الرئيسية", icon: "bi-house-door-fill" },
    {
      label: "الفعاليات",
      icon: "bi-building-fill",
      subItems: [
        { path: "/admin/establishments", label: "قائمة الفعاليات" },
        { path: "/admin/geo-map-report", label: "الخريطة الجغرافية" },
        { path: "/admin/visits-report", label: "تقرير الزيارات" },
        { path: "/admin/violation-report", label: "تقرير الضبوط" },
        // { path: "/admin/price-survey-report", label: "سبر الاسعار" },


        { path: "/admin/generate-uid", label: "توليد QR" },
        { path: "/admin/complaints-registry", label: "سجل الشكاوي" },
        { path: "/admin/complaints-matrix-report", label: "تقرير شكاوي مصفوفي" },
      ],
    },
    {
      label: "إدارة المستخدمين",
      icon: "bi-people-fill",
      adminOnly: true,
      subItems: [
        { path: "/admin/users-management", label: "المستخدمون" },
        { path: "/admin/roles-management", label: "الأدوار" },
        { path: "/admin/permissions-management", label: "الصلاحيات" },
        { path: "/admin/activities-management", label: "النشاطات" },
        { path: "/admin/facilitytypes-management", label: "أنواع الفعالية" },
      ],
    },
    {
      label: "المواد والأسعار",
      icon: "bi-tag-fill",
      subItems: [
        { path: "/admin/price-survey-categories", label: "تصنيفات المواد" },
        { path: "/admin/price-survey-products", label: "المواد والمنتجات" },
        { path: "/admin/price-survey-matrix-report", label: "تقرير سبر الأسعار اليومي" },
        { path: "/admin/price-survey-product-days-report", label: "تقرير سبر المادة الزمني" },
        // { path: "/admin/price-survey-report", label: "سبر الاسعار (تفصيلي)" },
        // { path: "/admin/price-average-survey-report", label: "تقرير متوسط الأسعار" },
        { path: "/admin/usd-exchange-rate", label: "سعر الدولار" },
      ],
    },
    {
      label: "الدوريات والمهام",
      icon: "bi-shield-shaded",
      subItems: [
        { path: "/admin/patrol-rosters", label: "الدوريات" },
        { path: "/admin/patrol-activity-matrix", label: "نشاط الدوريات" },
        { path: "/admin/i", label: "المهام" },
        { path: "/admin/violation-types-management", label: "أنواع الضبوط" },
        { path: "/admin/patrolstaff-management", label: "الموظفون" },
        { path: "/admin/location_management", label: "المواقع" },
      ],
    },
  ];

  return (
    <>
      {isOpen && (
        <div
          className="sidebar-mobile-overlay d-lg-none"
          onClick={toggleSidebar}
          aria-hidden="true"
        />
      )}

      <aside
        className="sidebar-pro d-flex flex-column"
        data-open={isOpen}
        data-scrolled={isScrolled}
      >
        <header className="sidebar-pro__header">
          <div className="sidebar-pro__brand">
            <div className="sidebar-pro__logo-wrap">
              <img src="/website-icon.png" alt="" width={32} height={32} />
            </div>
            <div>
              <p className="sidebar-pro__title mb-0">حماية المستهلك</p>
              <p className="sidebar-pro__subtitle mb-0">لوحة الإدارة</p>
            </div>
          </div>
          <button
            type="button"
            onClick={toggleSidebar}
            className="sidebar-pro__close"
            aria-label="إغلاق القائمة"
          >
            <i className="bi bi-chevron-double-right" />
          </button>
        </header>

        <nav className="sidebar-pro__nav flex-grow-1" aria-label="القائمة الرئيسية">
          <ul className="sidebar-pro__list">
            {menuStructure
              .filter((item) => !item.adminOnly || isAdmin)
              .map((item, index) => {
                const hasSub = !!item.subItems;
                const isParentActive =
                  hasSub &&
                  item.subItems.some((sub) =>
                    isRouteActive(location.pathname, sub.path)
                  );
                const isActive = !hasSub && isRouteActive(location.pathname, item.path);
                const isMenuOpen = openMenus[item.label] ?? isParentActive;

                return (
                  <li key={index} className="sidebar-pro__item">
                    {hasSub ? (
                      <>
                        <button
                          type="button"
                          onClick={() => toggleMenu(item.label)}
                          className={`sidebar-pro__parent ${isParentActive ? "is-active" : ""}`}
                          aria-expanded={isMenuOpen}
                        >
                          <span className="sidebar-pro__icon-wrap">
                            <i className={`bi ${item.icon}`} />
                          </span>
                          <span className="sidebar-pro__label">{item.label}</span>
                          <i
                            className={`bi bi-chevron-down sidebar-pro__chevron ${isMenuOpen ? "is-open" : ""}`}
                          />
                        </button>
                        <div className={`sidebar-pro__sub-wrap ${isMenuOpen ? "is-open" : ""}`}>
                          <ul className="sidebar-pro__sublist">
                            {item.subItems.map((sub, sIdx) => {
                              const subActive = isRouteActive(location.pathname, sub.path);
                              return (
                                <li key={sIdx}>
                                  <Link
                                    to={sub.path}
                                    className={`sidebar-pro__sublink ${subActive ? "is-active" : ""}`}
                                  >
                                    <span className="sidebar-pro__sublink-dot" aria-hidden />
                                    {sub.label}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <Link
                        to={item.path}
                        className={`sidebar-pro__link ${isActive ? "is-active" : ""}`}
                      >
                        <span className="sidebar-pro__icon-wrap">
                          <i className={`bi ${item.icon}`} />
                        </span>
                        <span className="sidebar-pro__label">{item.label}</span>
                      </Link>
                    )}
                  </li>
                );
              })}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
